module.exports = __webpack_public_path__ + "static/img/RWD666_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWD666_1.png
// module id = rues
// module chunks = 0